import * as React from "react";

import { cn } from "@/lib/utils";

// Figma "Toggle Row": label + 36x20 switch (State = On · Off), e.g. Certified / Free Trial / On-Premise.
export interface NvToggleRowProps {
  label: React.ReactNode;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
}

function NvToggleRow({ label, checked, onCheckedChange, disabled, className }: NvToggleRowProps) {
  const id = React.useId();
  return (
    <div className={cn("flex items-center justify-between gap-3 py-[6px]", className)}>
      <label htmlFor={id} className="text-nv-body-md text-nv-text-primary">
        {label}
      </label>
      <button
        id={id}
        type="button"
        role="switch"
        aria-checked={checked}
        disabled={disabled}
        onClick={() => onCheckedChange(!checked)}
        className={cn(
          "flex h-5 w-9 shrink-0 items-center rounded-nv-pill px-[2px] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-nv-brand disabled:opacity-40",
          checked ? "bg-nv-brand" : "bg-nv-bg-subtle",
        )}
      >
        <span
          className={cn(
            "h-4 w-4 rounded-full bg-nv-surface transition-transform",
            checked ? "translate-x-4" : "translate-x-0",
          )}
        />
      </button>
    </div>
  );
}

export { NvToggleRow };
